import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { included, coverImage } from '../data/content';
export function Includes() {
  return <section id="que-incluye" className="w-full border-y border-ink/5 bg-ivory py-20 sm:py-28" aria-labelledby="que-incluye-title" data-id="element-51" data-mp="3fhmywg9h1j1g">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-8" data-id="element-52" data-mp="3k9xy1gwe10sy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="order-2 lg:order-1" data-id="element-53" data-mp="3p9kbnrg4oj2a">
          <p className="font-sans text-xs uppercase tracking-[0.28em] text-gold-deep" data-id="element-54" data-mp="70jsw0mcs7pd">
            Qué incluye
          </p>
          <h2 id="que-incluye-title" className="mt-5 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-55" data-mp="23vy36kceg1ck">
            Todo lo que encontrarás dentro
          </h2>

          <ul className="mt-10 space-y-5" data-id="element-56" data-mp="3uhiqpq3vv0ul">
            {included.map(item => <li key={item} className="flex items-start gap-4" data-id="element-57" data-mp="3pn4mqzb5nleb">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-soft/40" data-id="element-58" data-mp="3lmb3wkckkwsa">
                  <CheckIcon className="h-3.5 w-3.5 text-gold-deep" strokeWidth={2.5} aria-hidden="true" data-id="element-59" data-mp="3gpaxu9fpzu16" />
                </span>
                <span className="font-sans text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-60" data-mp="d7snnvch6axl">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="order-1 flex justify-center lg:order-2" data-id="element-61" data-mp="3b7jfc8a53ut">
          <div className="relative" data-id="element-62" data-mp="2peep8km2aryu">
            <div className="absolute -inset-6 rounded-[2.5rem] bg-gold-soft/20" aria-hidden="true" data-id="element-63" data-mp="2ug44kcgbhrsq" />
            <img src={coverImage} alt="Portada del ebook Desde el miedo hacia la libertad" className="relative w-64 rounded-xl shadow-[0_24px_60px_-24px_rgba(58,46,36,0.45)] sm:w-80" loading="lazy" data-id="element-64" data-mp="2gfb5rfizgajt" />
          </div>
        </motion.div>
      </div>
    </section>;
}